import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { saveRequestToAddFood } from "../../../../features/mobile/mealSlice";
import { useNavigate } from "react-router-dom";
import HeadCont from "../../components/common/HeadCont";
import MenuBar from "../../components/common/MenuBar";
import PhotoCard from "../../components/common/PhotoCard";
import Btn from "../../components/common/Btn";
import Dialog from "../../components/common/Dialog";
import { resizeFile } from "../../../../common/util/base";

const RequestToAddFood = () => {
    const dispatch = useDispatch();
  const { loginInfo } = useSelector((state) => state.commonApp);
  const navigate = useNavigate();
  const [addFoodData, setAddFoodData] = useState({
    foodName: "",
    memo: "",
    camera: [],
  });
  const [loadedImage, setLoadedImage] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const onAddFoodData = (e) =>
    setAddFoodData({ ...addFoodData, [e.target.name]: e.target.value });
  const [openDialog, setOpenDialog] = useState(false);

  const titleFn = (title) => {
    return <h2 className="text-caption1_600 text-gray_160">{title}</h2>;
  };

  const descFn = (desc) => {
    return <h2 className="text-caption1_400 text-gray_160">{desc}</h2>;
  };

  const onAddThumbnail = async (e) => {
    let reader = new FileReader(); // Use FileReader API to read image
    let resize = await resizeFile(e.target.files[0]); // Read file with reader first
    reader.readAsDataURL(resize);
    setAddFoodData((prevData) => ({ ...prevData, camera: [resize] })); // Use functional update to preserve existing state
    reader.onload = (e) => {
      // Event handler after photo upload
      setLoadedImage(e.target.result); // Put data into img src for image preview
      e.target.value = ""; // Reset to detect same file upload
    };
  };

  const onSaveRequestToAddFood = () => {
    if (isSubmitting) return; // Prevent double submission

    setIsSubmitting(true);

    let params = {
      userId: loginInfo.userId,
      title: addFoodData.foodName,
      content: addFoodData.memo,
      files: addFoodData.camera,
    };

    dispatch(saveRequestToAddFood(params))
      .unwrap()
      .then((res) => {
        if (res.ok) {
          setOpenDialog(true);
          setAddFoodData({ foodName: "", memo: "", camera: [] });
          setLoadedImage(null);
        }
      })
      .catch((err) => {
        console.error('Error:', err);
        alert('Error submitting request: ' + (err.message || JSON.stringify(err)));
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  return (
    // prettier-ignore
    <>
        <HeadCont leftIcon={'no icon'} rightIcon={'close'} onRightAction={() => navigate(-1)} />
        <section className='px-6 py-4 safe-area-mt-header mb-28'>
            <h2 className='text-subtitle3 text-gray_180'>Request Food Addition</h2>
            <p className='text-body3_400 text-gray_160'>Can't find the food you're looking for? Let us know and we'll add it to our database.</p>
            <div className='mt-8 space-y-8'>
                <div className='space-y-6'>
                    <div>
                        {titleFn("Food Name")}
                        <textarea onChange={(e) => onAddFoodData(e)} value={addFoodData.foodName} className='w-full min-h-[66px] resize-none appearance-none border border-gray_80 rounded-md px-4 py-3 focus:outline-none focus:border-main text-body2_500 text-black placeholder:text-gray_120'
                            name='foodName' placeholder={"Enter the name of the food"} rows="2">
                        </textarea>
                        {descFn("For example: Grilled Chicken Breast, Brown Rice Bowl")}
                    </div>
                    <div>
                        {titleFn("Additional Details (Optional)")}
                        <textarea onChange={(e) => onAddFoodData(e)} value={addFoodData.memo} className='w-full min-h-[100px] resize-y appearance-none border border-gray_80 rounded-md px-4 py-3 focus:outline-none focus:border-main text-body2_500 text-black placeholder:text-gray_120'
                            name='memo' placeholder={"Add any details that might help us identify the food"} rows="3">
                        </textarea>
                    </div>
                    <div>
                        {!loadedImage && <>
                            {titleFn("Photo (Optional)")}
                            <PhotoCard onAddThumbnail={onAddThumbnail} option={true} />
                        </>}
                        {!loadedImage && descFn("Adding a photo helps us identify and add the food more accurately")}
                        {loadedImage &&
                            <div id='image_container' className='relative max-w-[327px] rounded-md text-body_2 text-gray_40 border'>
                                <img src={loadedImage} alt="Food image" className='w-[100%] h-auto' />
                                <span className='absolute w-8 h-8 top-2 right-2'>
                                    <img onClick={() => { setAddFoodData((prevData) => ({ ...prevData, camera: [] })); setLoadedImage(null); }} src='/images/mobile/icon/close_circle.svg' alt="Remove" /></span>
                            </div>}
                    </div>
                </div>
                <Btn bgColor={'bg-main'} textColor={'text-white'} borderColor={'border border-main'} title="Submit Request" active={isSubmitting ? 'loading' : (!addFoodData.foodName ? 'ready' : 'on')} onAction={onSaveRequestToAddFood} />
            </div>
        </section>
        {openDialog && <Dialog innerClass={'py-4 pl-6 pr-5'} btnClass={'mt-[17px]'} title="Request Submitted" desc="Thank you for your request! We'll review and add the food to our database soon."
            onRightBtnAction={() => { window.scrollTo(0, 0); navigate(-1) }} onCoverAction={() => { window.scrollTo(0, 0); navigate(-1) }} />}
        <MenuBar />
    </>
  );
};

export default RequestToAddFood;
